import { Chip } from "@mui/material";
import { Stack } from '@mui/material';
import { useRecordContext } from 'react-admin';

const RolesField = () => {
  const record = useRecordContext();

  if (record) {
    const roles = record.roles;

    // Define custom role priority
    const rolePriority = {
      admin: 1,
      designer: 2,
      trainer: 3,
      trainee: 4,
    };

    // Sort roles by the defined priority
    const sortedRoles = [...roles].sort((a, b) => (rolePriority[a] || 99) - (rolePriority[b] || 99));

    return (
      <Stack direction="row" spacing={1}>
        {sortedRoles.map(role => (
          <Chip color="primary" key={role} label={role} />
        ))}
      </Stack>
    );
  } else return null;
};

export default RolesField;